// Hafif dalgalanan Türk bayrağı ikonu — üst menüde logo yanında kullanılır.
export const TurkishFlag = ({ className = "" }) => (
  <svg
    viewBox="0 0 30 20"
    className={className}
    role="img"
    aria-label="Türk Bayrağı"
    data-testid="turkish-flag"
  >
    <rect width="30" height="20" rx="2.5" fill="#E30A17" />
    <circle cx="12.4" cy="10" r="5.4" fill="#FFFFFF" />
    <circle cx="13.7" cy="10" r="4.4" fill="#E30A17" />
    <polygon
      points="19.6,7.7 20.2,9.35 21.9,9.4 20.5,10.45 20.95,12.15 19.6,11.15 18.25,12.15 18.7,10.45 17.3,9.4 19,9.35"
      fill="#FFFFFF"
    />
  </svg>
);
